import React from 'react';
import classNames from 'classnames';


export interface AboutSectionProps {
    id?: string;
    className?: string;
    children?: any;
}

export function AboutSection(props: AboutSectionProps) {
    return (
        <section className="section" id={props.id}>
            <div className="container">
                <div className="columns is-vcentered is-variable is-8">
                    <div className="column">
                        <h1 className="title">
                            <span className="is-family-secondary">ABOUT</span>
                            コンテスト概要
                        </h1>
                        <p className="is-size-5 is-size-6-mobile is-margin-bottom-3">
                            FRESH CAMPUS CONTEST（通称：フレキャン）とは、大学新入生を対象とした日本最大級のコンテストです。
                            <br />
                            出場者の大学生活を全力でバックアップし、夢への最短距離をサポートします。
                            <br />
                            これまで、アナウンサー・ミスキャンパス・雑誌読者モデルなどを多数輩出しており、近年で最も在京キー局アナウンサーを輩出しているコンテストです。
                        </p>
                        <table className="table is-fullwidth">
                            <tbody>
                            <tr>
                                <th className="is-narrow"style={{verticalAlign: "middle"}}>主催</th>
                                <td>FRESH CAMPUS CONTEST 2019 実行委員会<br />
                                    株式会社エイジ・エンタテインメント</td>
                            </tr>
                            <tr>
                                <th className="is-narrow" style={{verticalAlign: "middle"}}>企画制作</th>
                                <td><figure className="image"><img src="/images/logo_misscolle.png" /></figure></td>
                            </tr>
                            <tr>
                                <th className="is-narrow" style={{verticalAlign: "middle"}}>特別協賛</th>
                                <td><figure className="image"><img src="/images/logo_rize.png" /></figure></td>
                            </tr>
                            <tr>
                                <th className="is-narrow" style={{verticalAlign: "middle"}}>特別協力</th>
                                <td><figure className="image"><img src="/images/logo_tv_asahi_ask_modelpress.png" /></figure></td>
                            </tr>
                            <tr>
                                <th className="is-narrow" style={{verticalAlign: "middle"}}>協賛</th>
                                <td><figure className="image"><img src="/images/logo_showroom_mysta.png" /></figure></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="column">
                        <img className="is-rounded has-shadow" src="/images/about@2x.jpg" />
                    </div>
                </div>
            </div>
        </section>
    )
}